export const manifest = {
  screens: {
    scr_p8uyhj: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_fj8mdz: { name: "About", route: "/about", position: {"x":1560,"y":220} },
    scr_d4j624: { name: "Facilities", route: "/facilities", position: {"x":160,"y":2200} },
    scr_m4d8pz: { name: "Facility Detail", route: "/facilities/indoor-pool", position: {"x":1560,"y":2200} },
    scr_fmli6t: { name: "Dining", route: "/dining", position: {"x":160,"y":4180} },
    scr_tes50p: { name: "Dining Detail", route: "/dining/the-godavari-room", position: {"x":1560,"y":4180} },
    scr_3s3k41: { name: "Sports", route: "/sports", position: {"x":160,"y":6160} },
    scr_al8wo8: { name: "Sports Detail", route: "/sports/golf", position: {"x":1560,"y":6160} },
    scr_ty1nf1: { name: "Banquets", route: "/banquets", position: {"x":160,"y":8140} },
    scr_kqbm1f: { name: "Banquet Detail", route: "/banquets/grand-ballroom", position: {"x":1560,"y":8140} },
    scr_4s3rq3: { name: "Accommodation", route: "/accommodation", position: {"x":4360,"y":14080} },
    scr_jt56h3: { name: "Events", route: "/events", position: {"x":160,"y":10120} },
    scr_4fkl6t: { name: "Event Detail", route: "/events/autumn-gala", position: {"x":1560,"y":10120} },
    scr_zqbqoy: { name: "Gallery", route: "/gallery", position: {"x":160,"y":14080} },
    scr_enczvq: { name: "Affiliated Clubs", route: "/affiliated-clubs", position: {"x":1560,"y":14080} },
    scr_c5ccpd: { name: "Committee", route: "/committee", position: {"x":2960,"y":14080} },
    scr_ghuxf6: { name: "Member Services", route: "/members", position: {"x":160,"y":12100} },
    scr_8p1hy4: { name: "Information to Members", route: "/members/information", position: {"x":1560,"y":12100} },
    scr_tpm4p4: { name: "Member Login", route: "/members/login", position: {"x":2960,"y":12100} },
    scr_gf57fl: { name: "Member Dashboard", route: "/members/dashboard", position: {"x":4360,"y":12100} },
    scr_xe6pnz: { name: "Member Card", route: "/members/card", position: {"x":5760,"y":12100} },
    scr_pikwjf: { name: "Contact", route: "/contact", position: {"x":160,"y":16060} },
    scr_9rrwuo: { name: "Policies", route: "/policies", position: {"x":1560,"y":16060} },
    scr_2hr32s: { name: "Admin Login", route: "/admin/login", position: {"x":160,"y":18040} },
    scr_g1fkua: { name: "Admin Dashboard", route: "/admin", position: {"x":1560,"y":18040} },
    scr_wd08xq: { name: "Admin Members", route: "/admin/members", position: {"x":2960,"y":18040} },
    scr_hxqyax: { name: "Admin Member Detail", route: "/admin/members/CH-1001", position: {"x":4360,"y":18040} },
  },
  sections: {
    sec_j76l84: { name: "Home & Primary", x: 0, y: 0, width: 2920, height: 1180 },
    sec_qphmyj: { name: "Facilities Browse", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_6s2wk3: { name: "Dining Browse", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_3nuemp: { name: "Sports Browse", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_01o5oc: { name: "Banquets Browse", x: 0, y: 7920, width: 2920, height: 1180 },
    sec_ybn36f: { name: "Events Browse", x: 0, y: 9900, width: 2920, height: 1180 },
    sec_lc88lb: { name: "Membership Portal", x: 0, y: 11880, width: 7120, height: 1180 },
    sec_xf2xgi: { name: "Club Information", x: 0, y: 13860, width: 5720, height: 1180 },
    sec_09xqr9: { name: "Support & Contact", x: 0, y: 15840, width: 2920, height: 1180 },
    sec_djio8t: { name: "Admin Portal", x: 0, y: 17820, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_j76l84", children: [
      { kind: "screen", id: "scr_p8uyhj" },
      { kind: "screen", id: "scr_fj8mdz" },
    ] },
    { kind: "section", id: "sec_qphmyj", children: [
      { kind: "screen", id: "scr_d4j624" },
      { kind: "screen", id: "scr_m4d8pz" },
    ] },
    { kind: "section", id: "sec_6s2wk3", children: [
      { kind: "screen", id: "scr_fmli6t" },
      { kind: "screen", id: "scr_tes50p" },
    ] },
    { kind: "section", id: "sec_3nuemp", children: [
      { kind: "screen", id: "scr_3s3k41" },
      { kind: "screen", id: "scr_al8wo8" },
    ] },
    { kind: "section", id: "sec_01o5oc", children: [
      { kind: "screen", id: "scr_ty1nf1" },
      { kind: "screen", id: "scr_kqbm1f" },
    ] },
    { kind: "section", id: "sec_ybn36f", children: [
      { kind: "screen", id: "scr_jt56h3" },
      { kind: "screen", id: "scr_4fkl6t" },
    ] },
    { kind: "section", id: "sec_lc88lb", children: [
      { kind: "screen", id: "scr_ghuxf6" },
      { kind: "screen", id: "scr_8p1hy4" },
      { kind: "screen", id: "scr_tpm4p4" },
      { kind: "screen", id: "scr_gf57fl" },
      { kind: "screen", id: "scr_xe6pnz" },
    ] },
    { kind: "section", id: "sec_xf2xgi", children: [
      { kind: "screen", id: "scr_zqbqoy" },
      { kind: "screen", id: "scr_enczvq" },
      { kind: "screen", id: "scr_c5ccpd" },
      { kind: "screen", id: "scr_4s3rq3" },
    ] },
    { kind: "section", id: "sec_09xqr9", children: [
      { kind: "screen", id: "scr_pikwjf" },
      { kind: "screen", id: "scr_9rrwuo" },
    ] },
    { kind: "section", id: "sec_djio8t", children: [
      { kind: "screen", id: "scr_2hr32s" },
      { kind: "screen", id: "scr_g1fkua" },
      { kind: "screen", id: "scr_wd08xq" },
      { kind: "screen", id: "scr_hxqyax" },
    ] },
  ],
}
